import React, { useRef } from 'react';
import { heroStats } from '../data/heroStats';
import { ScrollSwapLine } from './ScrollSwapLine';
import { LogoWall } from './LogoWall';

/**
 * The agency tagline, centered between "Let's make them feel something" and the statement.
 * Blurs over to the collaborations line once scrolled halfway up; the rotating client logo row sits below it.
 */
export function AgencyTagline() {
  const lineRef = useRef<HTMLParagraphElement>(null);
  return <div className="relative flex w-full flex-col items-center text-center" data-id="element-6" data-mp="3v67po4z5ngkt">
      {/* Phones: swaps 10% of the screen later, and the first line reads
          "We're an AI-first / Branding & Creative Agency" */}
      <ScrollSwapLine ref={lineRef} from={`We’re an ${heroStats[0]}`} to="256 brand collaborations in 7 years." mobileSwapAt={0.4} mobileBreakFromAfter={2} data-id="element-7" data-mp="3q4rzxzm18lw3" />
      <LogoWall triggerRef={lineRef} data-id="element-8" data-mp="1od59bz61yt05" />
    </div>;
}